<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" sm="12">
      <h1 class="mb-4">Заказы по промокоду</h1>
      <v-row align="center">
        <v-col cols="12" sm="4" md="3">
          <v-text-field
              v-model="filters.date_from"
              type="date"
              label="Дата от"
              outlined
              dense
              clearable
              hide-details
              :disabled="loading"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <v-text-field
              v-model="filters.date_to"
              type="date"
              label="Дата до"
              outlined
              dense
              clearable
              hide-details
              :disabled="loading"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="4" class="orders-filter-actions">
          <v-btn color="primary" :loading="loading" @click="loadOrders">Применить</v-btn>
          <v-btn text :disabled="loading" @click="clearFilters">Сбросить</v-btn>
        </v-col>
        <v-col class="text-right">
          <a href="/promocode">Назад</a>
        </v-col>
      </v-row>
      <v-alert v-if="errorMessage" type="error" outlined class="mt-4">{{ errorMessage }}</v-alert>
      <div class="orders-summary my-4" aria-live="polite">
        <span>Заказов: <strong>{{ summary.order_count }}</strong></span>
        <span>Сумма: <strong>{{ formatAmount(summary.order_amount) }}</strong></span>
      </div>
      <v-data-table
          no-data-text="Нет заказов"
          no-results-text="По заданному запросу ничего не найдено"
          :items="orders"
          :headers="headers"
          :loading="loading"
          :options.sync="options"
          :footer-props="footerProps"

          :items-per-page="-1"
          :hide-default-footer="false"
          loading-text="Загрузка заказов... Подождите пожалуйста"
      >
        <template v-slot:item.created_at="{ item }">
          {{ formatDate(item.created_at) }}
        </template>
      </v-data-table>
      <!--</v-card>-->
    </v-col>
  </v-row>
</template>

<script>
// @ is an alias to /src

import PromocodeService from '../../api/PromocodeService'
import moment from 'moment'

export default {
  name: 'ProductOrders',
  components: {},
  props: {
    id: {
      default: null,
    }
  },
  data: () => ({
    loading: true,
    errorMessage: '',
    requestId: 0,
    orders: [],
    filters: {
      date_from: null,
      date_to: null,
    },
    summary: {
      order_count: 0,
      order_amount: 0,
    },
    options: {},
    footerProps: {
      itemsPerPageText: 'Заказов на страницу',
      pageText: '{0}-{1} из {2}',
      itemsPerPageAllText: 'Все',
      itemsPerPageOptions: [-1]
    },
    headers: [
      {
        text: '№ Заказа',
        value: 'id',
        sortable: false
      },
      {
        text: '№ Телефона',
        value: 'phone',
        sortable: false
      },
      {
        text: 'Сумма Заказа',
        value: 'sum',
        sortable: false
      },
      {
        text: 'Дата Заказа',
        value: 'created_at',
        sortable: false
      },
    ],
  }),
  mounted() {
    this.loadOrders();
  },
  watch: {
    id() {
      this.loadOrders();
    },
  },
  methods: {
    loadOrders() {
      const requestId = ++this.requestId;
      this.errorMessage = '';
      if (this.filters.date_from && this.filters.date_to && this.filters.date_from > this.filters.date_to) {
        this.errorMessage = 'Дата до не может быть раньше даты от.';
        this.orders = [];
        this.summary = {order_count: 0, order_amount: 0};
        this.loading = false;
        return;
      }
      this.loading = true;

      const params = Object.keys(this.filters).reduce((result, key) => {
        if (this.filters[key]) {
          result[key] = this.filters[key];
        }
        return result;
      }, {});

      PromocodeService.listByPromo(this.id, params).then(res => {
        if (requestId !== this.requestId) return;
        const data = res.data;

        if (Array.isArray(data)) {
          this.orders = data;
          this.summary = {
            order_count: data.length,
            order_amount: data.reduce((sum, order) => sum + Number(order.sum || 0), 0),
          };
          return;
        }

        this.orders = data.orders || [];
        this.summary = data.summary || {order_count: 0, order_amount: 0};
      }).catch(error => {
        if (requestId !== this.requestId) return;
        this.orders = [];
        this.summary = {order_count: 0, order_amount: 0};
        this.errorMessage = error.response && error.response.status === 403
          ? 'Недостаточно прав для просмотра отчета.'
          : 'Не удалось загрузить отчет. Попробуйте снова.';
      }).finally(() => {
        if (requestId === this.requestId) this.loading = false;
      });
    },
    clearFilters() {
      this.filters.date_from = null;
      this.filters.date_to = null;
      this.loadOrders();
    },
    formatDate(value) {
      return value ? moment(value).format('DD.MM.YYYY HH:mm') : '';
    },
    formatAmount(value) {
      return Number(value || 0).toFixed(2);
    },
  }
}
</script>

<style>
.changed-row {
  background-color: #FFEEEC;
}
</style>

<style lang="scss" scoped>
.v-btn--fab.v-size--x-small {
  width: 20px;
  height: 20px;

  .mdi::before {
    font-size: 12px;
  }
}

span.v-btn {
  border-color: currentColor !important;
}

.filter-popup {
  position: absolute;
  width: 250px;
  z-index: 5;

  &:hover {
    cursor: auto;
  }


  &.v-card--link:focus::before {
    opacity: 0;
  }
}

.orders-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 32px;
  font-size: 18px;
}

.orders-filter-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
</style>
